import { gql } from 'src/generated/gql';

export const ACCEPT_PRESCRIPTION_TASK_MUTATION = gql(`
  mutation AcceptPrescriptionTask($taskId: ID!) {
    staff_acceptPrescriptionTask(taskId: $taskId) {
      id
      status
      acceptedBy
    }
  }
`);
